import React from 'react';
import { Modal } from '../Common/Modal';
import { VISIT_TYPES } from '../../utils/constants';
import { formatDateDDMMMYYYY } from '../../utils/dateFormat';
import './VisitActionsModal.css';

const PlannerVisitActionsModal = ({
  isOpen,
  onClose,
  suggested,
  // onConfirmSchedule,
  onModifySchedule,
  canSchedule = true,
}) => {
  const dateLabel = suggested?.suggestedDate
    ? formatDateDDMMMYYYY(suggested.suggestedDate + 'T12:00:00')
    : '';

  const siteDisplay = suggested?.siteCode || suggested?.siteName || '';

  const titleLine = suggested
    ? `Suggested SMV (${VISIT_TYPES.SMV || 'Site Monitoring Visit'}) - ${siteDisplay}`
    : '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
      title={`Visit Actions - ${dateLabel}`}
      className="visit-actions-modal planner-visit-actions-modal"
    >
      <div className="visit-actions-header">
        <div className="visit-actions-subtitle">
          {titleLine}
        </div>
        
      </div>

      <div className="visit-actions-buttons">
        {canSchedule && (
          <>
            {/* <button
              className="btn btn-primary btn-block"
              onClick={onConfirmSchedule}
            >
              Confirm Schedule
            </button> */}
            <button
              className="btn btn-primary btn-block"
              onClick={onModifySchedule}
            >
              Modify Schedule Visit
            </button>
          </>
        )}
        <button
          className="btn btn-outline-secondary btn-block"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default PlannerVisitActionsModal;
